'use client';

import { cn } from '@/lib/ui/cn';
import { cva, type VariantProps } from 'class-variance-authority';

const actionButtonVariants = cva(
  'rounded-[30px] px-[30px] py-[12px] font-sans text-[21px] leading-[130%] transition-colors gap-[10px] disabled:opacity-50 cursor-pointer',
  {
    variants: {
      variant: {
        primary: 'bg-[#292722] text-white hover:bg-[#BBBBBB]',
        secondary:
          'border border-[#BBBBBB] bg-white/80 text-[#292722] hover:bg-[#BBBBBB] hover:text-white hover:border-[#BBBBBB]',
        cream:
          'border border-[#292722] bg-sh-cream hover:bg-[#292722] hover:text-white',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
);

interface ActionButtonProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof actionButtonVariants> {
  label: string;
}

export function ActionButton({
  label,
  variant,
  className,
  ...props
}: ActionButtonProps) {
  return (
    <button
      className={cn(actionButtonVariants({ variant }), className)}
      {...props}
    >
      {label}
    </button>
  );
}

export { actionButtonVariants };
